"use client";

/**
 * Product thumbnail with a graceful fallback (2026-08-02, Phase C).
 *
 * Shared by the inline FastResults page and the SSR /c/list broad page. The
 * image slot carries the real Google Shopping thumbnail (CSP allows https
 * images); on a missing or failed image it shows a neutral placeholder glyph
 * instead of the browser's broken-image icon. Client component only for the
 * onError fallback; it still server-renders its initial HTML.
 */

import { useState } from "react";

function ThumbFallback() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.4}
      className="h-7 w-7"
      aria-hidden="true"
    >
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <path d="M21 15l-5-5L5 21" />
    </svg>
  );
}

export function ProductThumb({ src, alt }: { src: string | null; alt: string }) {
  const [failed, setFailed] = useState(false);
  const show = src && !failed;
  return (
    <div className="flex h-20 w-20 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-secondary text-muted-foreground sm:h-24 sm:w-24">
      {show ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={src}
          alt={alt}
          loading="lazy"
          onError={() => setFailed(true)}
          className="h-full w-full object-contain p-1"
        />
      ) : (
        <ThumbFallback />
      )}
    </div>
  );
}
